import { Routes } from '@angular/router';
import { PageTitleEnum } from '@shared/enums';
import { userGuard } from '@core/guards';

export const strainRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./_strains-layout/strains-layout.component').then(mod => mod.StrainsLayoutComponent),
        children: [
            {
                path: '',
                redirectTo: 'my-strains',
                pathMatch: 'full',
            },
            {
                path: 'my-strains',
                loadComponent: () =>
                    import('./strains-listing/strains-listing.component').then(mod => mod.StrainsListingComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.MY_STRAINS,
                data: { preload: true },
            },
            {
                path: 'create',
                loadComponent: () =>
                    import('./strain-create/strain-create-selection/strain-create-selection.component').then(
                        mod => mod.StrainCreateSelectionComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.CREATE_STRAIN,
            },
            {
                path: 'share',
                loadComponent: () =>
                    import('./strains-sharing/strains-sharing.component').then(mod => mod.StrainsSharingComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_SHARING,
            },
            {
                path: 'strain-information-form',
                loadComponent: () =>
                    import('./strain-create/strain-information-form/strain-information-form.component').then(
                        mod => mod.StrainInformationFormComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_INFORMATION_FORM,
            },
            {
                path: 'strain-duplicate',
                loadComponent: () =>
                    import('./strain-create/strain-duplicate/strain-duplicate.component').then(
                        mod => mod.StrainDuplicateComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_DUPLICATE,
            },
            {
                path: 'strain-crossing',
                loadComponent: () =>
                    import('./strain-create/strain-crossing/strain-crossing.component').then(
                        mod => mod.StrainCrossingComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_CROSSING,
            },
            {
                path: 'my-probes',
                loadComponent: () =>
                    import('./probe-listing/probe-listing.component').then(mod => mod.ProbeListingComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.MY_PROBES,
                data: { preload: true },
            },
            {
                path: 'sequencing-requests',
                loadComponent: () =>
                    import('./sequencing-requests/sequencing-requests.component').then(
                        mod => mod.SequencingRequestsComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.SEQUENCING_REQUESTS,
                data: { preload: true },
            },
            {
                path: 'faq',
                loadComponent: () => import('./strains-faq/strains-faq.component').then(mod => mod.StrainsFaqComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAINS_FAQ,
            },
            {
                path: 'create-from-probes',
                loadComponent: () =>
                    import('./strain-create/strain-create-from-probes/strain-create-from-probes.component').then(
                        mod => mod.StrainCreateFromProbesComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_CREATE_FROM_PROBES,
            },
        ],
    },
];
